// extracted by mini-css-extract-plugin
export default {"stickableMenu":"EmployeesPage_stickableMenu__A7dkT","placeHolderShimmer":"EmployeesPage_placeHolderShimmer__qki3l"};